<template>
  <span v-if="!to"
       v-bind="$attrs">
    <slot></slot>
  </span>
  <router-link v-else
               v-bind="$attrs"
               :to="computedTo">
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    props: {
      to: [String, Object]
    },
    computed: {
      computedTo() {
        if (
          (!this.$route.params.lang || this.$route.params.lang === 'ua') &&
          typeof this.to === 'object'
        ) {
          const newTo = {...this.to}

          if (!newTo.params) {
            newTo.params = {}
          }

          if (newTo.name && !newTo.name.endsWith('-double')) {
            newTo.name = newTo.name + '-double'
          }

          return newTo
        }

        return this.to
      }
    }
  }
</script>

<style lang="less">

</style>
